import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getMediaKitById } from "../../data/media_kit_data";

function MediaKitSlugDownload() {
  const { kitId, slug } = useParams();
  const navigate = useNavigate();
    const params = useParams();
  document.title = "MEDIA-KIT DOWNLOAD CGES.CLUB";

  useEffect(() => {
    const kit = getMediaKitById(kitId);
    // console.log("kit",kit);
    // console.log(kitId,"kitId");
    // console.log(slug,"slug");
    // console.log("PARAMS",params);
    const isSlugMatch =
      kit?.slug && slug && kit.slug.toLowerCase() === slug.toLowerCase();

    if (isSlugMatch && kit?.downloadurl) {
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = kit.downloadurl;
      document.body.appendChild(iframe);

      const timer = window.setTimeout(() => {
        navigate("/media-kit", { replace: true });
      }, 1200);

      return () => {
        window.clearTimeout(timer);
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
      };
    }

    navigate("/", { replace: true });
  }, [kitId, slug, navigate]);

  return null;
}

export default MediaKitSlugDownload;
